import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 2rem 2rem;
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledHeaderBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0 1rem;
  gap: 1rem;
  flex-wrap: wrap;
`;
